const addtocartPopup = () => {
  const cartButtons = document.querySelectorAll('.cart-button') as NodeListOf<HTMLElement>;
  const cartOverlay = document.querySelector('.yith-wacp-overlay') as HTMLElement;
  const miniCart = document.querySelector('#yith-wacp-mini-cart') as HTMLElement;
  const miniCartPopup = document.querySelector('#yith-wacp-popup') as HTMLElement;

  if (cartButtons) {
    [...cartButtons].forEach((cartButton) => {
      cartButton.addEventListener('click', () => {
        if (miniCartPopup && miniCartPopup.classList.contains('open') && cartOverlay) {
          cartOverlay.click();
        } else if (miniCart) {
          miniCart.click();
        }
      });
    });
  }
};

export default addtocartPopup;
